import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';
import algosdk from 'algosdk';
import { getNetworkConfig, getAlgodClient, NetworkType } from '../utils/algorandUtils';

interface NetworkContextType {
  network: NetworkType;
  config: ReturnType<typeof getNetworkConfig>; 
  algodClient: algosdk.Algodv2;
  toggleNetwork: () => void;
  ASA_UMQ: number;
  ASA_HLK: number;
}

const NetworkContext = createContext<NetworkContextType | undefined>(undefined);

export const NetworkProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [network, setNetwork] = useState<NetworkType>('Mainnet'); 

  const toggleNetwork = useCallback(() => {
    setNetwork(prev => prev === 'Mainnet' ? 'Testnet' : 'Mainnet');
  }, []);

  const contextValue = useMemo(() => {
    const config = getNetworkConfig(network);
    const algodClient = getAlgodClient(network);
    
    const ASA_UMQ = config.tokens.umq.id;
    const ASA_HLK = config.tokens.hlk.id;

    return {
      network,
      config,
      algodClient,
      toggleNetwork,
      ASA_UMQ,
      ASA_HLK,
    };
  }, [network, toggleNetwork]);

  return (
    <NetworkContext.Provider value={contextValue}>
      {children}
    </NetworkContext.Provider>
  );
};

export const useNetwork = () => {
  const context = useContext(NetworkContext);
  if (context === undefined) {
    throw new Error('useNetwork debe usarse dentro de un NetworkProvider. Verifica que has envuelto tu aplicación.');
  }
  return context;
};
